import  { useContext } from "react";
import ScrollToTop from "../scroll";
import { IonLabel, IonToolbar, IonButton, IonButtons, IonCard, IonCardContent, IonPage, IonHeader, IonContent } from "@ionic/react";
import { ArrowBackSharp } from "@mui/icons-material";
import { useHistory } from "react-router";
import { Colour, FontType, Hindit } from "../global";

export default function Donate() {
 let history = useHistory();
 const [clr,] = useContext(Colour);
 let color,colori, colorh;
 if(clr === "1") {
    color = "black";
    colori = ""
    colorh = "primary"
   }
   if(clr === "2") {
    color = "black";
    colori = "secondary"
    colorh = "warning"
   }
   if(clr === "3") {
    color = "black";
    colori = "secondary"
    colorh = "success"
   }
   if(clr === "4") {
    color = "black";
    colori = "secondary"
    colorh = "tertiary"
   }
   if(clr === "5") {
    color = "white";
    colori = "dark"
    colorh = "warning"
   }
   if(clr === "6") {
    color = "white";
    colori = "dark"
    colorh = "tertiary"
   }


 const [font,] = useContext(FontType);
 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";
 const [hindit,] = useContext(Hindit);

 return (
   <IonPage>
    <ScrollToTop />
    <IonHeader>
   <IonToolbar color={colorh}>
    <IonButtons slot="start" onClick={() => {
        if(history.length > 1){
          history.goBack()
        }else{
          history.push("/home");
        }
    }}>
     <IonButton>
     <ArrowBackSharp style={{ fontSize: 30 }} />
     </IonButton>
    </IonButtons>
    <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "दान" : "Donate"}</IonLabel>
   </IonToolbar>
   </IonHeader>
   <IonContent color={colori} scrollEvents={true}>
   <div style={{ padding: "10px", textAlign: "justify", textJustify: "auto" }}>
   {hindit ? 
     <p style={{ fontFamily: `${fon}` }}>
     मैं इस ऐप से कोई धन नहीं कमाता क्योंकि इसमें किसी भी प्रकार के विज्ञापन नहीं दिखाता और ना ही कोई छिपे खरीदारी होती है। इसके बजाय, मैं हर साल इस ऐप को ऐप स्टोर में बनाए रखने के लिए कुछ धन देना पड़ता हूँ। लेकिन, मुझे आपका आशीर्वाद और प्रार्थना धन से ज्यादा आवश्यक है, इसलिए, कृष्ण भक्ति में मेरा प्रगति के लिए कृपया प्रार्थना करें।
     </p>
    : 
    <p style={{  fontFamily: `${fon}` }}>
    I don't earn any money from this app as it doesn't display any ads or have any hidden purchases. Instead, I have to pay a certain amount of money every year to maintain this app in app stores. But, I need your blessings and prayers more than money. So, please pray for my advancement in Krishna Consciousness.
     </p>
   }
   <IonCard color={colori} style={{ color: `${color}`, fontFamily: "Calibri, sans-serif"  }}>
      <IonCardContent>
       {!hindit ? <>
      <p style={{ fontSize: "16px"  }} align="center">
      grantha-dwārā baiṣṇaba-janera kṛpā pāi
      <br />
      baiṣṇaba-kṛpāya kṛṣṇa-lābha hoya bhāi
     </p>
     <br />
     <p style={{ fontSize: "16px", textAlign: "justify"  }}>
      If all the devotees thus appreciate this book (app), then I will receive the causeless mercy that they will shower upon me. Oh brothers! And<b> by the mercy
      of all these Vaisnavas, I will attain devotion to the Supreme Lord Sri Kṛṣṇa.</b>
     </p>

     <p style={{ fontSize: "16px"  }} align="right">
      - Kalyanakalpataru
     </p>
     </> : <>
     <p style={{ fontSize: "16px"  }} align="center">
     ग्रन्थ-द्वारा बैष्णब-जनेर कृपा पाई
      <br />
      बैष्णब-कृपाय कृष्ण-लाभ होय भाई।
     </p>
     <br />
     <p style={{ fontSize: "16px", textAlign: "justify"  }}>
     अगर सभी भक्त इस पुस्तक (ऐप) को सराहते हैं, तो मुझ पर वे उस पर कृपा बरसाएंगे। हे भाईयों! और <b>इन सभी वैष्णवों की कृपा से, मैं सर्वोच्च भगवान श्री कृष्ण की भक्ति प्राप्त करूंगा।</b>
     </p>
     <p style={{ fontSize: "16px"  }} align="right">
      - कल्याणकल्पतरु
     </p>
     </>}
      </IonCardContent>
     </IonCard>
     </div>
   </IonContent>
   </IonPage>

 );
}
